import React from "react";
import { CheckCircle } from "lucide-react"; // nice clean icon

export default function RegistrationComplete() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="bg-white shadow-xl rounded-2xl p-8 max-w-md text-center">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <CheckCircle className="h-16 w-16 text-green-600" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Registration Complete 🎉
        </h1>

        {/* Message */}
        <p className="text-gray-600 mb-6">
          Your account has been created successfully. You can now log in and
          start using all features.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col space-y-3">
          <a
            href="/login"
            className="w-full px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition"
          >
            Go to Login
          </a>

          <a
            href="/dashboard"
            className="w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-100 transition"
          >
            Go to Dashboard
          </a>
        </div>
      </div>
    </div>
  );
}
